module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Конфиденциальность",
	"footer.privacy.url": "https://www.grohe.co.uk/en_gb/company/privacy.html",
	"footer.disclaimer.text": "Правовая оговорка",
	"footer.disclaimer.url": "https://www.grohe.co.uk/en_gb/company/legal-info.html",
	"footer.copyright": "&copy; 2017 GROHE Limited",
	"homepage.headline": "Подбор конфигурации водных систем GROHE",
	"homepage.introtext": "GROHE Blue или Red? Ответьте на несколько простых вопросов, и Вы узнаете, какое оборудование GROHE лучше всего удовлетворит Вашим потребностям.",
	"homepage.buttonStart": "Начать",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "Ошибка 404: страница не найдена",
	"404.link.goBack": "Вернуться на главную страницу",
	"configurator.button.seeResults": "Посмотреть результаты",
	"question1.question": "Есть ли на Вашей кухне и холодное, и горячее водоснабжение?",
	"question1.option1.text": "На моей кухне есть и холодное, и горячее водоснабжение",
	"question1.option2.text": "Есть только холодное водоснабжение",
	"question2.question": "Какая вода Вам необходима?",
	"question2.option1.text": "Кипящая вода для приготовления пищи и напитков",
	"question2.option2.text": "Охлажденная и газированная питьевая вода",
	"question2.option3.text": "Охлажденная и газированная, а также кипящая вода",
	"question3.question": "Вы хотите оставить имеющийся кухонный смеситель?",
	"question3.option1.text": "Я хочу его оставить",
	"question3.option2.text": "Я хочу установить новую модель",
	"question4.question": "Каким должен быть Ваш основной смеситель?",
	"question4.option1.text": "GROHE Blue Home",
	"question4.option2.text": "GROHE Red",
	"question5.question": "Какую форму излива Вы предпочитаете?",
	"question5.option1.text": "L-образный излив",
	"question5.option2.text": "U-образный излив",
	"question5.option3.text": "С-образный излив",
	"question6.question": "Какое покрытие Вы предпочитаете?",
	"question6.option1.text": "Хромированное",
	"question6.option2.text": "Суперсталь",
	"question7.question": "Какой объем бойлера Вам необходим?",
	"question7.option1.text": "Неприменимо",
	"question7.option2.text": "Объем L (5,5 литров)",
	"results.title": "{productGroupsCount, plural, \none {Ваш результат} \nother {Ваши результаты}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "Для надлежащего монтажа Вам также потребуется:",
	"results.newConfiguration.title": "Хотели бы Вы подобрать еще одну водную систему?",
	"results.newConfiguration.buttonText": "Подобрать конфигурацию для еще одной водной системы",
	"results.product.number": "Артикул: #{number}",
	"results.product.button.productInformation": "Описание модели",
	"results.product.button.dealerLocator": "Найти салон-магазин",
	"results.product.button.buyNow": "Неприменимо",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Описание модели",
	"results.product.dealer": "Найти салон-магазин",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/water.ru_ru.json
// module id = 793
// module chunks = 0